import {lazy} from 'react';
import {CheckInMapping} from './CheckInConstant';

const CheckInRouterView = lazy(() => import('./view/CheckInRouterView'));

export default [
    {id: CheckInMapping.checkInRouter, exact: true, component: CheckInRouterView},
];